function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  d: "M28.3 30.64c-.3-1.49-.36-3.02-1.23-4.38-.38-.6-.44-1.4-.66-2.1-.25-.79-.32-1.59-.24-2.42.06-.54.28-1.1 0-1.64-.3-.62-.56-1.27-1.1-1.74-.24-.22-.3-.46-.18-.78.18-.46.3-.94.25-1.44-.01-.26 0-.55-.43-.47-.26.05-.38-.1-.43-.38-.09-.53-.38-.89-.96-.94a.84.84 0 0 1-.41-.16c-.21-.16-.48-.3-.39-.65.03-.1.38.09.2-.21-.1-.17-.25-.16-.4-.06-.2.14-.42.05-.64.06-.39.01-.8.03-1.14.19-.11.05-.22.31-.44.44-.99.56-1.15.99-.87 2.12.05.24.01.38-.2.38-1.25-.05-2.54.29-3.7-.47-.32-.2-.68-.33-1.07-.32a1.42 1.42 0 0 1-1.32-.73c-.53-.88-1.08-1.74-1.6-2.62A6.4 6.4 0 0 0 9.2 10c-.28-.16-.65-.37-.86-.13-.42.5-.72.17-1.07-.03-.27-.15-.54-.31-.82-.43-.35-.16-.65-.02-.53.36.25.75-.06 1.36-.26 2.04-.23.77-.6 1.32-1.3 1.65-.43.2-.43.49-.24.88.35.7.95.95 1.65 1.1.38.1.89.1.9.7 0 1.4.7 2.64.96 4 .26 1.34.72 2.65 1 4 .26 1.3.38 2.64.6 3.96.1.53.08 1.05.04 1.59-.06.72-.59.87-1.1 1.08-.17.08-.28.23-.26.43.03.2.99.55 1.3.65 1.4.44 2.29-.01 2.71-1.4.48-1.57.56-3.2.8-4.8.14-.9.18-.94 1.05-.9 1.45.06 2.78-.36 4.11-.87.46-.17.94-.63 1.5-.33.73.39 1.4.88 1.78 1.67.37.77.98 1.36 1.56 1.97.53.57.96 1.22.97 2.07 0 .7-.28 1.17-.88 1.51-.2.11-.3.42-.06.56.5.28 1.04.2 1.56.08.41-.1.55-.44.56-.81.04-1.47.43-2.99-.57-4.32-.03-.05-.03-.12-.06-.25.26 0 .44.1.52.23.58.89 1.45 1.55 1.9 2.55.38.86.55 1.65-.17 2.4-.22.24-.28.53.06.64.49.16 1.04.22 1.49-.04.42-.24.35-.73.26-1.16zm-17.6-3.11a8.84 8.84 0 0 1-.31 2.64s.29-1.44.03-3.05c-.26-1.6.22-2.48.22-2.48s.08 1.6.06 2.89z",
  clipRule: "evenodd"
});

var SvgDogSizeSmall = function SvgDogSizeSmall(props) {
  return React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), _ref);
};

export default __webpack_public_path__ + "e20ad1411752699ee45c193528e743ff.svg";
export { SvgDogSizeSmall as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ../icons/svg/dog-size-small.svg
// module id = null
// module chunks = 